"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _Link = _interopRequireDefault(require("../../typography/Link"));

var _default = function _default(className, actionClassName, actions, onClickAction) {
  return /*#__PURE__*/_react.default.memo(function (_ref) {
    var children = _ref.children,
        props = (0, _objectWithoutProperties2.default)(_ref, ["children"]);
    return _reactSelect.components.Menu && /*#__PURE__*/_react.default.createElement(_reactSelect.components.Menu, (0, _extends2.default)({}, props, {
      className: className
    }), children, actions && /*#__PURE__*/_react.default.createElement("div", {
      className: actionClassName
    }, actions.map(function (action, idx) {
      return /*#__PURE__*/_react.default.createElement(_Link.default, {
        key: idx,
        className: "hoi-poi-select__action",
        onClick: function onClick() {
          onClickAction && onClickAction(action);
          action.onClick && action.onClick();
        }
      }, action.label);
    })));
  });
};

exports.default = _default;